import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../Models/BaseComponent';
import { QuestionProcessingService } from '../services/question-processing.service';
import { DennysFlow, WOTCCategory } from '../Models/dennysFlow';
import { TouchEventService } from '../services/touch-event.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-dennys-flow2',
  templateUrl: './dennys-flow2.component.html',
  styleUrls: ['./dennys-flow2.component.css']
})
export class DennysFlow2Component extends BaseComponent implements OnInit {
  questions: QuestionProcessingService;
  ReceivedSNAPText : string;
  SNAPPaymentsText : string;
  AgeRangeValidText : string;
  constructor(public location : Router,  questions: QuestionProcessingService, public swiper : TouchEventService) {
    super(swiper,location);
    this.questions = questions;
    this.category = WOTCCategory.SNAP;
    super.setupQuestion();
    super.SetVerbiage(this.questions.language, this.currentQuestion);
  }

  updateProgress($event){
    this.setPercentComplete()
  }

  ngOnInit() {
    super.ngOnInit()
  }

  back(){
     super.back('/d1');
  }

  continue(){
    super.continue('/d3');
  }
}



// WEBPACK FOOTER //
// C:/git/SynergiPartners 7-Eleven Screening/src/app/dennys-flow2/dennys-flow2.component.ts